module.exports = __webpack_public_path__ + "img/img_index_thumb_sms_intro_1.073a0551.jpg";